import { ExternalInvitation } from '@/domain/external-invitation/entities/external-invitation.entity';
import { InviteCategory } from '@/domain/external-invitation/entities/invitation-category';
import { Sector } from '@/domain/impact/impact.entity';
import { FSModal } from '@/ui/components/modal/FSModal';

import { AssignExternalView } from './assign-external/AssignExternalView';
import { InviteSubmitData } from './assign-external/components/FormExternalInvite';

export function ModalAssignExternal({
  open,
  onClose,
  sector,
  categories,
  existingInvitations,
  onSubmitInvite,
}: {
  open: boolean;
  onClose: () => void;
  sector: Sector;
  categories?: InviteCategory[];
  existingInvitations: ExternalInvitation[];
  onSubmitInvite: (data: InviteSubmitData) => void;
}) {
  return (
    <FSModal
      open={open}
      onClose={onClose}
      maxWidth={1200}
      showCloseButton={true}
    >
      <AssignExternalView
        sector={sector}
        categories={categories}
        existingInvitations={existingInvitations}
        onSubmitInvite={onSubmitInvite}
      />
    </FSModal>
  );
}
